import React, { useEffect,useState} from "react";
import {useSelector, useDispatch,shallowEqual} from "react-redux";
import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import TextFieldWrapper from "@common/TextFieldWrapper";
import { Kjua } from 'react-kjua';
import { loginActions } from '@redux/actionCreators/UserActions';

const contentSx = {
    '& .text-field':{
        width:300,
        mt:2,
        '& input':{fontSize: 42,letterSpacing:20},
        '& legend':{fontSize: 13,width:158},
        "& label": {
            top: -3,
            fontSize: "16px",
            lineHeight: "24px",
        },
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink':{ transform: 'translate(14px, -9px) scale(1)'},
    },
    '& .qr-ctr':{
        '& div':{
            display:'flex',
            justifyContent:'center'
        }
    }
}
const TOTPSetup = ({postVerify,email,onCancel,opts={}})=>{
    const dispatch = useDispatch();
    const [state,setState] = useState({open:true,code:'',uri:''});
    const toggle = (open,opt={})=>{
        setState({...opt,open});
    }
    const onClose = ()=>{
      toggle(false);
      onCancel();
    }
    const onConfirm = async (e)=>{
        if(!state.code){
            setState(pv=>({...pv,error:"Authentication Code is required"}))
        }
        else{
            try{
                await dispatch(loginActions.verifyTOTPSetup(state.code));
                postVerify(opts);
                toggle(false);
            }
            catch(err){
                setState(pv=>({...pv,error:err.message}))
            }
        }
    }
    const setURI = async ()=>{
        const {secretKey,setupUri} = await dispatch(loginActions.setUpTOTP('iNaira Platform',email));
        setState(pv=>({...pv,uri:setupUri.href}));        
    }
    useEffect(()=>{
        setURI();
    },[])
    const onChange = (e)=>setState(pv=>({...pv,code:e.target.value}));
    return <Dialog
            sx={{zIndex:1500, '& .MuiDialog-paper': { width: '500px'} }}
            //maxWidth={state.maxWidth || maxWidth}
            //keepMounted
            open={state.open}
            className={`confirm-dialog`}
          >
            <DialogTitle sx={{textAlign:'center',fontWeight:700,p:2.5}}>
                Configure Authenticator app
            </DialogTitle>
            <DialogContent sx={contentSx}>
              <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
                <Box sx={{mb:1}} className="qr-ctr">
                    <label>In your 2FA compatible app, please scan following QR code</label>
                    <Kjua text={state.uri}/>
                    <label>After the application is configured, please enter the authentication code </label>
                </Box>
                <TextFieldWrapper 
                    className="text-field"
                    error={!!state.error}
                    helperText={state.error}
                    label="Authentication Code" 
                    variant="outlined" 
                    inputProps={{maxLength:6}}
                    InputLabelProps={{ shrink: true }} 
                    wrapType="number"
                    validationOptions={{maxLength:6}}
                    value={state.code}
                    onChange={onChange}/>
              </Box>
            </DialogContent>
            <DialogActions sx={{px:2,py:3,justifyContent:'center'}}>
              <Button autoFocus onClick={onClose} variant="outlined">
                Cancel
              </Button>
              <Button color="primary" variant="contained" onClick={onConfirm}>Confirm Setup</Button>
            </DialogActions>
          </Dialog>
}

export default TOTPSetup;